﻿// ------------------------------------------------------------------------- //
// #ORGANIZATION
// ------------------------------------------------------------------------- //
import GroTranslator from './translator';

window.farmday = window.farmday || {};
farmday.modules = farmday.modules || {};

farmday.modules.organization = (function () {
    
    const validateSilos = () => {
        var isValid = true;
        $('input.silo-number').each(function (idx, item) {
            var $item = $(item);
            var numberValue = $item.val();
            var valid = !!numberValue && numberValue.toString() !== '';
            if (!valid) {
                isValid = false;
                $item.addClass('error');
            } else if ($item.hasClass('error')) {
                $item.removeClass('error');
            }
        });
        return isValid;
    }

    var priv = {};
    /**
     * Private initialization method
     */
    priv.init = function () {

        // Validate delivery address / Silos.
        if ($('.js-page-identifier-organization-delivery-address').length) {

            $('ul.errors-list li').each(function (idx, item) {
                $(item).hide();
            });

            if ($.validator) {
                $('#editDeliveryAddress').validate({
                    ignore: [],
                    errorElementClass: 'error',
                    errorClass: 'error-item',
                    errorElement: 'span',
                    rules: {
                        AdressStreet: 'required',
                        ZipCode: {
                            required: true,
                            zipCode: true,
                        },
                        Place: {
                            required: true,
                        },
                        SilosName: {
                            subItemRequired: validateSilos,
                        },
                        MobileNumber: {
                            required: true,
                            mobileSE: true,
                        },
                    },
                    messages: {
                        AdressStreet: GroTranslator.get('/common/validation/address/required'),
                        ZipCode: {
                            required: window['validationMessage'].zipCode.required,
                            zipCode: window['validationMessage'].zipCode.valid,
                        },
                        Place: {
                            required: GroTranslator.get('/common/validation/city/required'),
                        },
                        SilosList: {},
                        MobileNumber: {
                            required: window['validationMessage'].mobileSE.required,
                            mobileSE: window['validationMessage'].mobileSE.valid,
                        },
                    },
                    highlight: function (element, errorClass, validClass) {
                        $('ul.errors-list').show();
                        $('li#li_' + $(element).attr('id')).show();
                        $(element)
                            .addClass(this.settings.errorElementClass)
                            .removeClass(errorClass);
                    },
                    unhighlight: function (element, errorClass, validClass) {
                        if ($(element).hasClass('silo-number')) {
                            return;
                        }
                        $(element)
                            .removeClass(this.settings.errorElementClass)
                            .removeClass(errorClass);
                        $('li#li_' + $(element).attr('id')).hide();
                        if ($('ul.errors-list').find('li[id^="li"]').is(':visible') === false) {
                            $('ul.errors-list').hide();
                        }
                    },
                });
            }
        }
    };

    // Initialize module
    $(function () {
        priv.init();
    });
})();
